/**
 * Detects a webpack lazy-chunk load failure.
 *
 * Webpack's runtime sets `error.name = 'ChunkLoadError'` and
 * `error.message = 'Loading chunk <id> failed.\n(error: <url>)'`. The chunk id is
 * numeric when `namedChunks: false` (beta/staging/prod) but a descriptive name
 * (e.g. `src_app_feature_client-user_client-user_module_ts`) when `namedChunks: true`
 * (the dev build). Match on `name` first — webpack always sets it — and fall back to a
 * message regex that accepts non-numeric chunk ids, so the guard fires on every build.
 */
export function isChunkLoadError(error: unknown): boolean {
  const e = error as { name?: string; message?: string } | null;
  const name: string = e?.name || '';
  const message: string = e?.message || '';
  return name === 'ChunkLoadError' || /ChunkLoadError|Loading chunk \S+ failed/i.test(message);
}

export function retryDynamicImport<T>(importer: () => Promise<T>, retries: number = 2): Promise<T> {
  return importer().catch((error: unknown) => {
    if (retries > 0 && isChunkLoadError(error)) {
      return retryDynamicImport(importer, retries - 1);
    }
    throw error;
  });
}
